<form [formGroup]="extraInformatieEWS">
    <div class="row">
      <div class="col-7 pt-3">
        <p>In {{ this.aangifte.aangifteJaar }} betaalde rente over andere jaren</p>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="renteInDitJaarVoorAndereJaren"
                                          id="dubbelePositie"
                                          class="custom-input-150"
                                          [decimals]="0"
                                          align="right"
                                          prefix="€"
                                          label="Bedrag"
                                          (change)="saveForm()"

        >
        </snelstart-ui-number-form-control>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <p>In een ander jaar betaalde rente over {{ aangifte.aangifteJaar }}</p>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="renteInVoorgaandeJarenBetaaldVoorDitJaar"
                                          id="renteInVoorgaandeJarenBetaaldVoorDitJaar"
                                          class="custom-input-150"
                                          [decimals]="0"
                                          align="right"
                                          prefix="€"
                                          (change)="saveForm()"

        >
        </snelstart-ui-number-form-control>
      </div>
    </div>


    <div class="row">
      <div class="col-7">
        <p>Belast deel van in {{ aangifte.aangifteJaar }} ontvangen uitkering kapitaalverzekering eigen
          woning</p>
      </div>
      <div class="col-5">
        <snelstart-ui-number-form-control formControlName="belastDeelKapitaalverzekeringEigenWoningen"
                                          id="belastDeelKapitaalverzekeringEigenWoningen"
                                          class="custom-input-150"
                                          [decimals]="0"
                                          align="right"
                                          prefix="€"
                                          (change)="saveForm()"

        >
        </snelstart-ui-number-form-control>
      </div>
    </div>

</form>
